import React from 'react';
import { Form, Modal, Select } from 'antd';

const DesktopQuickStatusUpdate = ({
  open,
  loading,
  onClose,
  onSubmit,
  form,
  orderStatusOptions,
  paymentStatusOptions,
  shippingStatusOptions,
  internalStatusOptions,
}) => {
  return (
    <Modal
      title="Cập nhật nhanh trạng thái"
      open={open}
      onCancel={onClose}
      onOk={onSubmit}
      okText="Lưu"
      cancelText="Huỷ"
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Trạng thái đơn hàng"
          name="order_status"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái đơn hàng' }]}
        >
          <Select options={orderStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái thanh toán"
          name="payment_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái thanh toán' }]}
        >
          <Select options={paymentStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái vận chuyển"
          name="shipping_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái vận chuyển' }]}
        >
          <Select options={shippingStatusOptions} />
        </Form.Item>

        <Form.Item
          label="Trạng thái nội bộ"
          name="internal_status_id"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái nội bộ' }]}
        >
          <Select options={internalStatusOptions} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DesktopQuickStatusUpdate;
